import HomeIcon from "@mui/icons-material/Home";
import { Typography } from "@mui/material";
import type { FallbackProps } from "react-error-boundary";

import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { BlButton } from "Shared/Buttons/BlButton";
import { UnauthenticatedLayout } from "Shared/Layouts/UnauthenticatedLayout";
import { UnstyledLink } from "Shared/Routing/UnstyledLink";

export const ApplicationErrorPage = (props: FallbackProps): React.ReactNode => {
  const { error } = props;
  const { t } = useResource();

  return (
    <UnauthenticatedLayout title={t(Resources.Errors.ApplicationError.Title)}>
      <Typography variant="h4">
        {t(Resources.Errors.ApplicationError.Subtitle)}
      </Typography>
      <br />
      <Typography>
        {t(Resources.Errors.ApplicationError.Description)}
      </Typography>
      <br />

      <UnstyledLink to="/">
        <BlButton
          startIcon={<HomeIcon />}
          size="large"
          variant="contained"
          color="primary"
        >
          {t(Resources.Errors.ApplicationError.Home)}
        </BlButton>
      </UnstyledLink>

      <br />

      <Typography>{t(Resources.Errors.ApplicationError.DebugHint)}</Typography>

      <pre>
        {/* @ts-expect-error */}
        <code>{JSON.stringify(error?.name)}</code>
      </pre>
      <pre>
        {/* @ts-expect-error */}
        <code>{JSON.stringify(error?.message)}</code>
      </pre>
    </UnauthenticatedLayout>
  );
};
